/* @flow */

import React from 'react'
import Basic from './basic'
import type { BasicPropsType, BasicStateType } from './basic'

export type TextAreaPropsType = BasicPropsType & {
  placeholder?: string,
  focused?: boolean,
  maxLength?: number | string,
  minLength?: number | string,
  onBlur?: any,
  onFocus?: any,
  onKeyPress?: any,
  onKeyDown?: any,
  onKeyUp?: any,
  disabled?: boolean,
  readOnly?: boolean,
  tabIndex?: number,
  wrap?: string,
  inputClassName?: string
}

type AbstractTextAreaStateType = BasicStateType & {}

type TextAreaStateType = AbstractTextAreaStateType & {}

class AbstractTextArea<Props: TextAreaPropsType, State: AbstractTextAreaStateType> extends Basic<Props, State> {
  props: Props

  static defaultProps = {
    ...Basic.defaultProps,
    inputClassName: 'atp-input__textarea'
  }

  formField(): React$Element<*> {
    const props = this.getProps()
    return (
      <textarea
        id={this.id}
        className={props.inputClassName}
        placeholder={props.placeholder}
        value={String(this.value)}
        onChange={this.getValue}
        onKeyPress={props.onKeyPress}
        onKeyDown={props.onKeyDown}
        onKeyUp={props.onKeyUp}
        maxLength={props.maxLength}
        minLength={props.minLength}
        name={props.name}
        onFocus={props.onFocus}
        onBlur={props.onBlur}
        disabled={props.disabled}
        readOnly={props.readOnly}
        tabIndex={props.tabIndex}
        ref={this.inputRef}
      />
    )
  }
}

class TextArea extends AbstractTextArea<TextAreaPropsType, TextAreaStateType> {}

class TextAreaOnly extends AbstractTextArea<TextAreaPropsType, TextAreaStateType> {
  props: TextAreaPropsType

  render(): React$Element<*> {
    return this.formField()
  }
}
export default TextArea
export { TextAreaOnly }
